
const Constants = {
   SetCorrespondent: 'message_setCorrespondent',
   SetMessages: 'message_setMessages',
   SetOverview: 'message_setOverview',
};

exports.Reducer = (state={},action) =>{
   switch(action.type){
      case Constants.SetCorrespondent:
         return {...state, correspondent: action.correspondent};
      case Constants.SetMessages:{
         return {...state, messages: action.messages}
      }
      case Constants.SetOverview:{
         return {...state, overview: action.overview}
      }
      default:
         return state;
   }
};

const FunctionList = {};

FunctionList.setCorrespondent = (correspondent) => {
   return{
      type: Constants.SetCorrespondent,
      correspondent
   }
};

FunctionList.setMessages = (messages) => {
   return{
      type: Constants.SetMessages,
      messages
   }
};

FunctionList.setOverview = (overview) => {
   return{
      type: Constants.SetOverview,
      overview
   }
};

exports.FunctionList = FunctionList;
